export const CURL_OPTION_DEFINITIONS = [
  { value: '', label: '选择常用参数…', placeholder: '', requiresValue: false },
  { value: 'query', label: '查询参数', placeholder: 'page=1', requiresValue: true },
  { value: 'header', label: '-H / 请求头', placeholder: 'Accept: application/json', requiresValue: true },
  { value: 'headerJson', label: '-H / JSON Content-Type', placeholder: '无需填写', requiresValue: false },
  { value: 'acceptJson', label: '-H / 接收 JSON', placeholder: '无需填写', requiresValue: false },
  { value: 'headerForm', label: '-H / URL Encoded 表单', placeholder: '无需填写', requiresValue: false },
  { value: 'bearer', label: 'Bearer Token', placeholder: '输入 Token', requiresValue: true },
  { value: 'basic', label: '-u / Basic Auth', placeholder: 'username:password', requiresValue: true },
  { value: 'json', label: '--data-raw / JSON', placeholder: '{"name":"Alice"}', requiresValue: true },
  { value: 'form', label: '-F / 表单字段', placeholder: 'name=Alice', requiresValue: true },
  { value: 'dataUrlencode', label: '--data-urlencode', placeholder: 'q=hello world', requiresValue: true },
  { value: 'cookie', label: '-b / Cookie', placeholder: 'session=abc123', requiresValue: true },
  { value: 'maxTime', label: '--max-time / 总超时', placeholder: '30', requiresValue: true },
  { value: 'connectTimeout', label: '--connect-timeout', placeholder: '10', requiresValue: true },
  { value: 'output', label: '-o / 输出文件', placeholder: 'response.json', requiresValue: true },
  { value: 'follow', label: '-L / 跟随重定向', placeholder: '无需填写', requiresValue: false },
  { value: 'compressed', label: '--compressed / 自动解压', placeholder: '无需填写', requiresValue: false },
  { value: 'insecure', label: '-k / 忽略证书校验', placeholder: '无需填写', requiresValue: false },
  { value: 'verbose', label: '-v / 详细日志', placeholder: '无需填写', requiresValue: false },
  { value: 'silent', label: '-sS / 静默但显示错误', placeholder: '无需填写', requiresValue: false },
  { value: 'http2', label: '--http2', placeholder: '无需填写', requiresValue: false },
];

const definitionMap = new Map(CURL_OPTION_DEFINITIONS.map((item) => [item.value, item]));

export function buildCurlCommand({ url: rawUrl, method = 'GET', options = [] }) {
  let url = rawUrl.trim();
  if (!url) throw new Error('请输入请求 URL。');
  if (!/^https?:\/\//i.test(url)) throw new Error('URL 需要以 http:// 或 https:// 开头。');
  const normalizedMethod = method.toUpperCase();
  if (!/^[A-Z]+$/.test(normalizedMethod)) throw new Error('请求方法无效。');

  const clauses = [`-X ${normalizedMethod}`];
  const queryItems = [];
  for (const item of options) {
    if (!item.enabled || !item.type) continue;
    const definition = definitionMap.get(item.type);
    if (!definition) continue;
    const value = item.value.trim();
    if (definition.requiresValue && !value) throw new Error(`“${definition.label}”需要填写参数值。`);

    if (item.type === 'query') queryItems.push(value);
    else appendCurlOption(clauses, item.type, value);
  }
  url = appendQueryItems(url, queryItems);
  clauses.push(shellQuote(url));
  return `curl \\\n${clauses.map((clause) => `  ${clause}`).join(' \\\n')}`;
}

export function shellQuote(value) {
  return `'${String(value).replaceAll("'", `'"'"'`)}'`;
}

function appendQueryItems(url, items) {
  if (!items.length) return url;
  const parsed = new URL(url);
  for (const item of items) {
    const separator = item.indexOf('=');
    const key = separator < 0 ? item : item.slice(0, separator);
    const value = separator < 0 ? '' : item.slice(separator + 1);
    if (key.trim()) parsed.searchParams.append(key.trim(), value);
  }
  return parsed.toString();
}

function appendCurlOption(clauses, type, value) {
  const pairs = {
    header: ['-H', value],
    bearer: ['-H', `Authorization: Bearer ${value}`],
    basic: ['-u', value],
    form: ['-F', value],
    dataUrlencode: ['--data-urlencode', value],
    cookie: ['-b', value],
    maxTime: ['--max-time', value],
    connectTimeout: ['--connect-timeout', value],
    output: ['-o', value],
  };
  if (type === 'json') {
    clauses.push(`-H ${shellQuote('Content-Type: application/json')}`, `--data-raw ${shellQuote(value)}`);
  } else if (pairs[type]) {
    clauses.push(`${pairs[type][0]} ${shellQuote(pairs[type][1])}`);
  } else {
    const flags = {
      headerJson: `-H ${shellQuote('Content-Type: application/json')}`,
      acceptJson: `-H ${shellQuote('Accept: application/json')}`,
      headerForm: `-H ${shellQuote('Content-Type: application/x-www-form-urlencoded')}`,
      follow: '-L',
      compressed: '--compressed',
      insecure: '-k',
      verbose: '-v',
      silent: '-sS',
      http2: '--http2',
    };
    if (flags[type]) clauses.push(flags[type]);
  }
}
